export class MassModel {
  name: string;
  churchId: string;
  link: string;
  date: string;
  time: string;
  timezone: string;
  timestamp: number;
  live: boolean;

  constructor(){
    this.name = "";
    this.churchId = "";
    this.link = "";
    this.date = '';
    this.time = '';
    this.timezone = '';
    this.timestamp = 0;
    this.live = false;
  }
}
